import { render, staticRenderFns } from "./RecordRow.vue?vue&type=template&id=6e43e127&scoped=true"
import script from "./RecordRow.vue?vue&type=script&lang=js"
export * from "./RecordRow.vue?vue&type=script&lang=js"
import style0 from "./RecordRow.vue?vue&type=style&index=0&id=6e43e127&prod&lang=scss&scoped=true"
import style1 from "./RecordRow.vue?vue&type=style&index=1&id=6e43e127&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e43e127",
  null
  
)

/* custom blocks */
import block0 from "@/locales2/share/orderTools.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fpartner%2Fcomponents%2Frecords%2Flist_view%2FRecordRow.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports